import React from "react";
import {useState,useEffect} from "react";
import {useLocation,useNavigate} from "react-router-dom";
import Grid from "@mui/material/Grid";
import LinearProgress from "@mui/material/LinearProgress";
import {Box} from "@mui/system";
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import {Dialog} from "primereact/dialog";
import {confirmDialog} from "primereact/confirmdialog";
import {ConfirmDialog} from "primereact/confirmdialog";
import {BlockUI} from "primereact/blockui";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import Message from "../Helpers/Message.js";
import {fetch_url_post} from "../../Sources/js/app.js";

let oper="";

let defaultInputValues={
	id: null,
	name: "",
	abbr: "",
	observations: "",
	filter_mus: "",
};

let defaultDataValues={
	MUsList: [],
};

let defaultDialogValues={
	openAddEdit: false,
	titleAddEdit: "",
};

let defaultInputError={
	disableSave: false,
	errorText: "",
};

let initialValue={};

const ProductsMUs = (props) => {

	var timerId=null;
	defaultInputValues.id=(props.MUId?props.MUId:null);

	const [inputValues, setInputValues] = useState(defaultInputValues);
	const [dataValues, setDataValues] = useState(defaultDataValues);
	const [messageText, setMessageText] = useState(null);
	const [dataOk, setDataOk] = useState(false);
	const [dialogValues, setDialogValues] = useState(defaultDialogValues);
	const [inputError, setInputError] = useState(defaultInputError);	
	const [blockScreen, setBlockScreen] = useState(false);
	const [MUsList, setMUsList] = useState([]);
    const location = useLocation();
    const navigate = useNavigate();

	const handleChange = evt => {
		const {name, value} = evt.target;
		if(name==="name") {
			let found=false;
			if(dataValues.MUsList.length>0) {
				dataValues.MUsList.forEach(element => {
					if((value.toUpperCase()===element.name.toUpperCase())&&((value!==initialValue.name)||(!initialValue))) {
						found=true;
					}
				});
			}
			let tmp={
				disableSave: found,
				errorText: (found===true?"Exista deja o unitate cu acest nume!":""),
			}
			setInputError(tmp);
		}
		if(name==="filter_mus") {
			setMUsList(dataValues.MUsList.filter((mu)=>((mu.name.toLowerCase().indexOf(value.toLowerCase())>-1))||(value==="")));
		}
		setInputValues({...inputValues,[name]:value});
	}

	const handleChecked = (evt) => {
		const {name, checked} = evt.target;
		if(checked) {
			setInputValues({...inputValues,[name]:1});			
		}else{
			setInputValues({...inputValues,[name]:0});			
		}
	}	

	const handleButton = (evt,what,elementData) => {
		if(what==="add") {
			setInputValues(defaultInputValues);
			setDialogValues({...dialogValues,openAddEdit: true,titleAddEdit: "Adaugare unitate de masura"});
			setInputError(defaultInputError);
		}
		if(what==="edit") {
			elementData.filter_mus=inputValues.filter_mus;
			initialValue=elementData;
			setInputValues(elementData);
			setDialogValues({...dialogValues,openAddEdit: true,titleAddEdit: "Editare U.M. "+elementData.name});
			setInputError(defaultInputError);
		}
		if(what==="delete") {
			let url="deleteProductMU";
			url+="?session_id="+props.session.sessId;
			oper="delete";
			let data={
				id: elementData.id,
			};
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
		if(what==="save") {
			document.querySelectorAll("input").forEach((element)=>element.classList.remove("required_input_error"));
			if(inputValues.name==="") {
				setMessageText("Eroare: Completati campul nume!");				
				document.getElementById("name").classList.add("required_input_error");
				return false;
			}
			if(inputValues.address==="") {
				setMessageText("Eroare: Completati campul abreviere!");				
				document.getElementById("abbr").classList.add("required_input_error");
				return false;
			}
			let url="saveProductMUSimple";
			url+="?session_id="+props.session.sessId;
			oper="save";
			let data={...inputValues};
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
	}

	const success_handler = (result) => {
		setBlockScreen(false);
		if(timerId) {
			clearTimeout(timerId);
			setMessageText("");
		}
		if(result.ok===0) {
			setMessageText("Eroare: "+result.error);
			return false;
		}
		if(result.is_auth===0) {
			navigate("/login");			
			return false;
		}
		if(result.message) {
			setMessageText(result.message);			
		}
		if((oper==="get")||(oper==="save")||(oper==="delete")) {
			setDialogValues(defaultDialogValues);
			setDataValues({...dataValues,MUsList:(result.MUsList?result.MUsList:[])});
			setMUsList(result.MUsList?result.MUsList.filter((mu)=>((mu.name.toLowerCase().indexOf(inputValues.filter_mus.toLowerCase())>-1))||(inputValues.filter_mus==="")):[]);
            if(!dataOk) {
                setDataOk(true);
            }
			oper="";
		}
	}

	const fail_handler = () => {
		setBlockScreen(false);
		if(timerId) {
			clearTimeout(timerId);
		}
		setMessageText("Eroare de conexiune. Va rugam sa incercati mai tarziu!");
	}

	const wait_handler = () => {
		setBlockScreen(true);
		setMessageText("Operatiunea este in curs...");
	}

	useEffect(() => {
		if(props.session.sessId) {
			oper="get";
			let url="getProductsMUs";
			url+="?session_id="+props.session.sessId;
			let data={};
			fetch_url_post(url,data,success_handler,fail_handler);
		}else{
			navigate("/login");
		}
	},[props.session.sessId]);

	const addEditDialog = () => {
		return(
			<Dialog header={dialogValues.titleAddEdit} visible={true} onHide={(evt)=>setDialogValues({...dialogValues,openAddEdit:false})} className="responsive-dialog-small">
				<Grid container spacing={1} style={{"paddingTop":"12px","maxHeight":"72vh"}}>
					<Grid item xs={12} sm={12} md={8} lg={9} className="field padding-min">
						<label htmlFor="name">Nume*</label>
						<InputText name="name" id="name" style={{"width":"100%"}} value={inputValues.name} onChange={(evt) => handleChange(evt)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={4} lg={3} className="field padding-min">
						<label htmlFor="abbr">Abreviere</label>
						<InputText name="abbr" id="abbr" style={{"width":"100%"}} value={inputValues.abbr} onChange={(evt) => handleChange(evt)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12} className="field padding-min">
						<label htmlFor="observations">Observatii</label>
						<InputText name="observations" id="observations" style={{"width":"100%"}} value={inputValues.observations} onChange={(evt) => handleChange(evt)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={7} style={{"textAlign":"left","marginTop":"21px"}}>
						<div style={{"color":"#FF0000","fontWeight":"600","paddingTop":"0px"}}>
							{inputError.errorText}
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={5} style={{"textAlign":"right","marginTop":"12px"}}>
						<Button label="Salveaza" icon="pi pi-check-circle" className="p-button-sm p-button-success p-button-raised" style={{"marginRight":"6px"}} onClick={(evt) => handleButton(evt,"save")} disabled={inputError.disableSave}/>
						<Button label="Inchide" icon="pi pi-times" className="p-button-sm p-button-danger p-button-raised" onClick={(evt)=>setDialogValues({...dialogValues,openAddEdit:false})}/>
					</Grid>
				</Grid>
			</Dialog>
		);
	}

	const tableColTemplate = (row_data,column) => {
		if(column.field==="buttons") {
			return(
				<span>
					<Button label="Editare" icon="pi pi-pencil" tooltip="Editeaza U.M." className="p-button-sm p-button-raised" style={{"marginRight":"3px"}} onClick={(evt) => handleButton(evt,"edit",row_data)}/>
					<Button label="Stergere" icon="pi pi-trash" tooltip="Sterge U.M." className="p-button-sm p-button-raised p-button-danger" onClick={(evt) => confirm(evt,"delete",row_data)}/>
				</span>
			);
		}
	}

	const confirm = (evt,what,elementData) => {
		if(what==="delete") {
			confirmDialog({
				message: "Sigur doriti stergerea?",
				header: "Confirmare stergere",
				icon: "pi pi-exclamation-triangle",
				accept: () => handleButton(evt,what,elementData),
				reject: () => null,
			});
		}
	}

	if(dataOk) {
		return(
			<BlockUI blocked={blockScreen} fullScreen>
				<div>
					<Grid container spacing={1} style={{}}>
						<Grid item xs={12} sm={4} md={4} lg={3} xl={3} className="field padding-med">
							<InputText name="filter_mus" id="filter_mus" style={{"width":"100%"}} value={inputValues.filter_mus} placeholder="Cauta unitate..." onChange={(evt) => handleChange(evt)}/>							
						</Grid>						
						<Grid item xs={12} sm={4} md={4} lg={6} xl={6} className="field padding-med text-left">
							<h6 style={{"marginTop":"9px","color":"#000000"}}>{MUsList.length} {(((MUsList.length>1)||(MUsList.length===0))?" inregistrari gasite.":" inregistrare gasita.")}</h6>
						</Grid>						
						<Grid item xs={12} sm={4} md={4} lg={3} xl={3} className="field padding-med text-right">
							<Button label="Adauga unitate noua" icon="pi pi-plus-circle" className="p-button-sm p-button-primary p-button-raised" style={{}} onClick={(evt) => {handleButton(evt,"add")}}/>
						</Grid>						
					</Grid>
					<Box sx={{ display: { xs: "none", sm: "none", md: "block", lg: "block", xl: "block" } }}>
						<div className="card">
							<DataTable
								value={MUsList}
								scrollable
								scrollHeight="60vh"
								style={{"minHeight":"63vh"}}
								scrollDirection="both"
								stripedRows
								resizableColumns
								columnResizeMode="fit"
								emptyMessage="Nu exista inregistrari"
							>
								<Column field="name" header="Nume" style={{"flexGrow":"1","flexBasis":"120px"}} sortable></Column>
								<Column field="abbr" header="Abreviere" style={{"flexGrow":"1","flexBasis":"90px"}}></Column>
								<Column field="reg_date_parsed" header="Data introducerii" style={{"flexGrow":"0","flexBasis":"180px"}} sortable></Column>
								<Column field="buttons" header="" style={{"flexGrow":"0","flexBasis":"195px"}} body={tableColTemplate}></Column>
							</DataTable>
						</div>
					</Box>
					<Box sx={{ display: { xs: "block", sm: "block", md: "none", lg: "none", xl: "none" } }}>

					</Box>
				</div>
				<ConfirmDialog />
				{messageText && <Message text={messageText} closeHandler={()=>setMessageText(null)}/>}
				{dialogValues.openAddEdit && addEditDialog()}
            </BlockUI>
		);
	}else{
		return(
			<React.Fragment>
				<LinearProgress />
				{messageText && <Message text={messageText} closeHandler={()=>setMessageText(null)}/>}
			</React.Fragment>
		);		
	}
};

export default ProductsMUs;


